/* eslint-disable warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';

import { service } from '@ember/service';
import GroupType from '@linc-technologies/linced-common/enums/group-type';
import { hash } from '@linc-technologies/linced-common/utils/promise';
import moment from 'moment';

export default class YearLevelCountsRoute extends Route {
  queryParams = {
    date: {
      refreshModel: true,
    },
  };

  // Services
  @service
  schoolSchema;

  @service
  store;

  // State
  year = moment().format('YYYY');

  model(params) {
    let year = params.date
      ? moment(params.date, 'YYYY-MM-DD').year()
      : this.year;

    return hash({
      homerooms: this.store.query('group', {
        groupType: GroupType.HOMEROOM,
        year,
      }),
      enrolments: this.store.query('people/enrolment', {
        asAtDate: params.date,
        include: 'people',
      }),
      genderField: this.schoolSchema.getLearnerGenderField(),
    });
  }
}
